import "../assets/scss/components/home/planos.scss";

export const GlobalVariables = {

  combos: {
    cinemaHBO: {
      title: {
        h4: `Cinema + `,
        span: `HBO Max™`,
      },
      product: {
        id: "PROMPKSC3783",
        name: "UOL PLAY Cinema",
        description: "UOL PLAY -> Cinema",
        category: "UOL Play",
        btn_text: "Experimente 7 dias",
        url: "https://conta.uol.com.br/login?t=cad-uol-play&env=checkout&dest=https%3A%2F%2Fcheckout.uol.com.br%2F%23%2Fuol-play%2F0%3Fpromotion%3DPROMPKSC3783",
        unit_price: 69.9,
        unit_sale_price: 0,
        sku_code: 23048,
        periodicity: 1,
        cancelText: `Cancele quando quiser`,
        contentTitle: `Conteúdos do seu combo:`,
      },
      quantity: 1,
      subtotal: "69,90",
      specs: [
        {
          span: `HBO Max™`,
          text: `por 1 mês * `,
        },
        {
          span: `4`,
          text: `perfis`,
        },
        {
          span: `2`,
          text: `telas ao mesmo tempo `,
        },
        {
          span: `+`,
          text: `controle parental `,
        },
      ],
    },

    cinema: {
      title: `Cinema`,
      product: {
        id: "PROMPKSC3782",
        name: "UOL PLAY Cinema",
        description: "UOL PLAY -> Cinema",
        category: "UOL Play",
        btn_text: "Experimente 7 dias",
        url: "https://conta.uol.com.br/login?t=cad-uol-play&env=checkout&dest=https%3A%2F%2Fcheckout.uol.com.br%2F%23%2Fuol-play%2F0%3Fpromotion%3DPROMPKSC3782",
        unit_price: 69.9,
        unit_sale_price: 0,
        sku_code: 23048,
        periodicity: 1,
        cancelText: `Cancele quando quiser`,
        contentTitle: `Conteúdos do seu combo:`,

      },
      quantity: 1,
      subtotal: "69,90",
      specs: [
        {
          span: `4`,
          text: `perfis`,
        },
        {
          span: `2`,
          text: `telas ao mesmo tempo `,
        },
        {
          span: `+`,
          text: `controle parental `,
        },
      ],
    },

    light: {
      title: `Light`,
      product: {
        id: "PROMPKSC3619",
        name: "UOL PLAY",
        description: "UOL PLAY -> Light",
        category: "UOL Play",
        btn_text: "Experimente 7 dias",
        url: "https://conta.uol.com.br/login?t=cad-uol-play&env=checkout&dest=https%3A%2F%2Fcheckout.uol.com.br%2F%23%2Fuol-play%2F0%3Fpromotion%3DPROMPKSC3781",
        unit_price: 24.9,
        unit_sale_price: 0,
        sku_code: 22128,
        periodicity: 1,
        cancelText: `Cancele quando quiser`,
        contentTitle: `Conteúdos do seu combo:`,
      },
      quantity: 1,
      subtotal: "24,90",
      specs: [
        {
          span: `4`,
          text: `perfis`,
        },
        {
          span: `2`,
          text: `telas ao mesmo tempo `,
        },
        {
          span: `+`,
          text: `controle parental `,
        },
      ],
    },

    familia: {
      product: {
        id: "PROMPKSC3617",
        name: "UOL PLAY -> Família",
        description: "UOL PLAY -> Família",
        category: "UOL Play",
        btn_text: "Experimente 7 dias",
        url: "https://cadastro.uol.com.br/indexb.html?eos=yes&skin=cadastrounificado/visitor/pf&skinPath=uol-play&promochild=PROMPKSC3449&redir=false&pca=uol-play&dest=",
        unit_price: 69.9,
        unit_sale_price: 0,
        sku_code: 23040,
        periodicity: 1
      },
      quantity: 1,
      subtotal: "69,90"
    },

    familiaBlackFriday: {
      product: {
        id: "PROMOCOMBOPLAY",
        name: "UOL PLAY -> Família",
        description: "UOL PLAY -> Família",
        category: "UOL Play",
        btn_text: "Experimente 7 dias",
        url: "https://cadastro.uol.com.br/indexb.html?eos=yes&skin=cadastrounificado/visitor/pf&skinPath=uol-play&promochild=PROMOCOMBOPLAY&redir=false&dest=",
        unit_price: "69,90",
        unit_sale_price: "49,90",
        sku_code: 23040,
        periodicity: 1
      },
      quantity: 1,
      subtotal: "69,90"
    },
  },

  liveChannels: {
    name: 'Ao Vivo',
    channels: [
      {
        name: "Warner TV",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-ao-vivo-on-demand/logo-warner.svg`,
        plans: ["cinema", "familia", "lineares"]
      },
      {
        name: "AXN",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-ao-vivo-on-demand/logo-axn.svg`,
        plans: ["cinema", "familia"]
      },
      {
        name: "Sony Channel",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-ao-vivo-on-demand/logo-sonychannel_new.svg`,
        plans: ["cinema", "familia"]
      },
      {
        name: "Sony Movies",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-ao-vivo-on-demand/logo-sonymovies.svg`,
        plans: ["cinema", "familia"]
      },
      {
        name: "History",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-ao-vivo-on-demand/logo-history.svg`,
        plans: ["cinema", "familia"]
      },
      {
        name: "History2",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-ao-vivo-on-demand/logo-history2.svg`,
        plans: ["cinema", "familia"]
      },
      {
        name: "Paramount Network",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-ao-vivo-on-demand/logo-paramountnetwork.svg`,
        plans: ["cinema", "familia"]
      },
      {
        name: "MTV",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-ao-vivo-on-demand/logo-mtv.svg`,
        plans: ["cinema", "familia"]
      },
      {
        name: "MTV Live",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-ao-vivo-on-demand/logo-mtvlive.svg`,
        plans: ["cinema", "familia"]
      },
      {
        name: "Band Sports",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-ao-vivo-on-demand/BandSports_logo.svg`,
        plans: ["torcedor", "cinema", "familia"]
      },
      {
        name: "Band",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-ao-vivo-on-demand/logo_Band.svg`,
        plans: ["torcedor", "cinema", "familia"]
      },
      {
        name: "Band News",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-ao-vivo-on-demand/logo_BandNews_tv.svg`,
        plans: ["torcedor", "cinema", "familia"]
      },
      {
        name: "Comedy Central",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-ao-vivo-on-demand/logo-comedycentral.svg`,
        plans: ["cinema", "familia"]
      },
      {
        name: "Lifetime",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-ao-vivo-on-demand/logo-lifetime.svg`,
        plans: ["cinema", "familia"]
      },
      {
        name: "Nickelodeon",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-ao-vivo-on-demand/logo-nickelodeon_2023.svg`,
        plans: ["cinema", "familia"]
      },
      {
        name: "Nickjr",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-ao-vivo-on-demand/logo-nickjr.svg`,
        plans: ["cinema", "familia"]
      },
      {
        name: "A&E",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-ao-vivo-on-demand/logo-ae.svg`,
        plans: ["cinema", "familia"]
      },
      {
        name: "Agro",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-ao-vivo-on-demand/logo-agro.svg`,
        plans: ["torcedor", "cinema", "familia"]
      },
      {
        name: "Arte1",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-ao-vivo-on-demand/logo-arte1.svg`,
        plans: ["torcedor", "cinema", "familia"]
      },
      {
        name: "Terra Viva",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-ao-vivo-on-demand/logo-terraviva.svg`,
        plans: ["torcedor", "cinema", "familia"]
      },
      {
        name: "Sabor e Arte",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-ao-vivo-on-demand/logo_Sabor_Arte.svg`,
        plans: ["torcedor", "cinema", "familia"]
      },
      {
        name: "New Brasil",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-ao-vivo-on-demand/logo_NewBrasil.svg`,
        plans: ["torcedor", "cinema", "familia"]
      },
    ],
  },

  onDemand: {
    name: 'On Demand',
    channels: [
      {
        name: "Paramount+",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-on-demand/logo-paramount.svg`,
        plans: ["light", "torcedor", "cinema", "cinemaHBO","total-receba-20","total", "familia", "play-paramount"]
      },
      {
        name: "Cultura",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-on-demand/logo_cultura.svg`,
        plans: ["torcedor", "cinema", "cinemaHBO","total-receba-20","total", "familia", "play-paramount"]
      },
      {
        name: "UOL Play Original",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-on-demand/logo_UOL_Originais.svg`,
        plans: ["light", "torcedor", "cinema", "mov", "cinemaHBO", "familia", "play-paramount", "total", "receba-20", "lineares", "cinemaHboTri"]
      },
      {
        name: "Belas Artes",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-on-demand/logo-base-ALaCarte_new.svg`,
        plans: ["torcedor", "cinema", "mov", "cinemaHBO", "familia", "total", "lineares", "cinemaHboTri"]
      }

    ],
  },

  original: {
    name: 'On Demand',
    channels: [
      {
        name: "UOL Play Original",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-on-demand/logo_UOL_Originais.svg`,
        plans: ["light", "torcedor", "cinema", "mov", "cinemaHBO", "familia", "play-paramount", "total", "receba-20", "lineares", "cinemaHboTri"]
      },
      {
        name: "Cultura",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-on-demand/logo_cultura.svg`,
        plans: ["torcedor", "cinema", "cinemaHBO","total-receba-20","total", "familia"]
      },,
      {
        name: "Belas Artes",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-on-demand/logo-base-ALaCarte_new.svg`,
        plans: ["torcedor", "cinema", "mov", "cinemaHBO", "familia", "total", "lineares", "cinemaHboTri"]
      }
    ]
  },

  originalparamount: {
    name: 'On Demand',
    channels: [
      {
        name: "UOL Play Original",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-on-demand/logo_UOL_Originais.svg`,
        plans: ["light", "torcedor", "cinema", "mov", "cinemaHBO", "familia", "play-paramount", "total", "receba-20", "lineares", "cinemaHboTri"]
      },
      {
        name: "Paramount+",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-on-demand/logo-paramount.svg`,
        plans: ["light", "torcedor", "cinema", "cinemaHBO","total-receba-20","total", "familia", "play-paramount"]
      }
    ]
  },

  originalaovivo: {
    name: 'On Demand',
    channels: [
      {
        name: "UOL Play Original",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-on-demand/logo_UOL_Originais.svg`,
        plans: ["light", "torcedor", "cinema", "mov", "cinemaHBO", "familia", "play-paramount", "total", "receba-20", "lineares", "cinemaHboTri"]
      }
    ]
  },

  onDemandHBO: {
    name: 'On Demand',
    channels: [
      {
        name: "Max",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-on-demand/logo_MAX.svg`,
        plans: ["torcedor", "cinemaHBO", "total-receba-20","total","familia"]
      },
      {
        name: "Paramount+",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-on-demand/logo-paramount.svg`,
        plans: ["light", "torcedor", "total-receba-20","total","cinema", "cinemaHBO", "familia", "play-paramount"]
      },
      {
        name: "Cultura",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-on-demand/logo_cultura.svg`,
        plans: ["torcedor", "cinema", "cinemaHBO", "familia","total-receba-20","total"]
      },
      {
        name: "UOL Play Original",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-on-demand/logo_UOL_Originais.svg`,
        plans: ["light", "torcedor", "cinema", "mov", "cinemaHBO", "familia", "play-paramount", "total", "total-receba-20","receba-20", "lineares", "cinemaHboTri"]
      },
      {
        name: "Belas Artes",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-on-demand/logo-base-ALaCarte_new.svg`,
        plans: ["torcedor", "cinema", "mov", "cinemaHBO", "familia", "total", "receba-20", "lineares", "cinemaHboTri"]
      }
    ],
  },

  canaisAdicionais: {
    name: 'Canais adicionais',
    channels: [
      {
        name: "HBO Max™",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-canais-adicionais/logo_MAX.svg`,
        plans: ["torcedor", "cinema", "familia"]
      },
      {
        name: "NBA",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-canais-adicionais/logo-nba.svg`,
        plans: ["torcedor", "cinema", "familia"]
      },
      {
        name: "Weburn",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-canais-adicionais/logo-weburn.svg`,
        plans: ["torcedor", "cinema", "familia"]
      },
      {
        name: "Belas Artes",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-on-demand/logo-base-ALaCarte_new.svg`,
        plans: ["torcedor", "cinema", "familia"]
      },
      {
        name: "UFC",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-canais-adicionais/logo-ufc.svg`,
        plans: ["torcedor", "cinema", "familia"]
      },
      {
        name: "Paramount Plus",
        image: `https://imguol.com.br/p/pp/uol-play/logos-parceiros/logos-on-demand/logo-paramount.svg`,
        plans: ["torcedor", "cinema", "familia"]
      }
    ],
  },

  faq: {
    title: 'Perguntas',
    titleSpan: 'frequentes',
    description: 'Estamos aqui para ajudar, se você ainda tem dúvidas sobre o produto entre em contato com a nossa Central de Atendimento.',
    phone1: '4003-2002',
    phone1Description: 'Capitais e regiões metropolitanas',
    phone2: '0800 771 7774',
    phone2Description: 'Demais localidades',
  },

  vantagens: {
    title: {
      h3: `Cliente UOL sempre tem`,
      span: `mais vantagens`
    },
    items: [
      {
        img: `https://imguol.com.br/p/pp/uol-play/logos-vantagens/icon_uoly.png`,
        imgAltText: `UOL`,
        title: `Suporte 24/7`,
        description: `Uma equipe sempre pronta para te ajudar no que você precisar.`,
      },
      {
        img: `https://imguol.com.br/p/pp/uol-play/logos-vantagens/icon_clubeuol.svg`,
        title: `Clube UOL`,
        imgAltText: `Clube UOL`,
        description: `Ofertas exclusivas em lojas online, restaurantes e muito mais.`,
        linkText: `Ver mais`,
        linkUrl: `https://clube.uol.com.br/?utm_source=UPL_credibilidade-conheca&utm_medium=UPL_credibilidade&utm_campaign=upl-conheca-link-clube&utm_content=upl-clube`,

      },
      {
        img: `https://imguol.com.br/p/pp/uol-play/logos-vantagens/icon_celular.svg`,
        title: `Aplicativo Meu UOL`,
        imgAltText: `App Meu UOL`,
        description: `Feito para você gerenciar seus produtos UOL.`,
        linkText: `Baixar app`,
        linkUrl: `https://produtos.uol.com.br/appmeuuol?utm_source=UPL_credibilidade-conheca&utm_medium=UPL_credibilidade&utm_campaign=upl-conheca-link-appmeuuol&utm_content=upl-appmeuuol`,
      },
    ],
    social: {
      description: `Siga nossos perfis nas redes sociais e fique por dentro dos lançamentos, dicas de novos filmes e séries e
        muito mais.`,
      items: [
        {
          name: `Instagram`,
          img: `https://imguol.com.br/p/pp/uol-play/logos-vantagens/btn_instagram.svg`,
          url: `https://www.instagram.com/uol_play?utm_source=UPL_credibilidade-conheca&utm_medium=UPL_credibilidade&utm_campaign=upl-conheca-link-ig&utm_content=upl-ig`,
        },
        {
          name: `Facebook`,
          img: `https://imguol.com.br/p/pp/uol-play/logos-vantagens/btn_facebook.svg`,
          url: `https://www.facebook.com/uolplay?utm_source=UPL_credibilidade-conheca&utm_medium=UPL_credibilidade&utm_campaign=upl-conheca-link-fb&utm_content=upl-fb`,
        },
        {
          name: `Youtube`,
          img: `https://imguol.com.br/p/pp/uol-play/logos-vantagens/btn_youtube.svg`,
          url: `https://www.youtube.com/channel/UCHSpTrCaGVi2TrZiXrKJsKQ?utm_source=UPL_credibilidade-conheca&utm_medium=UPL_credibilidade&utm_campaign=upl-conheca-link-yt&utm_content=upl-yt`,
        },
        {
          name: `Twitter`,
          img: `https://imguol.com.br/p/pp/uol-play/logos-vantagens/btn_twitter.svg`,
          url: `https://twitter.com/uol_play`,
        },
        {
          name: `Tiktok`,
          img: `https://imguol.com.br/p/pp/uol-play/logos-vantagens/btn_tiktok.svg`,
          url: `https://www.tiktok.com/@uol_play`,
        },
        {
          name: `Pinterest`,
          img: `https://imguol.com.br/p/pp/uol-play/logos-vantagens/btn_pinterest.svg`,
          url: `https://br.pinterest.com/uol/uol-play/`,
        },
      ]
    },
  },
  // Campanha de Black Friday, deixar false
  blackFriday: false

}

export default GlobalVariables;
